export default __webpack_public_path__ + "static/media/Clan Bound Belt of the Golden Horde.47ac8631.jpg";